import { COMMON_SET_CHANNEL_INFO, COMMON_SET_WHATSAPP_CHANNEL_INFO } from './constants';

export function setChannelInfo(data) {
  return {
    type: COMMON_SET_CHANNEL_INFO,
    data,
  };
}

export function setWhatsappChannelInfo(data) {
  return {
    type: COMMON_SET_WHATSAPP_CHANNEL_INFO,
    data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SET_CHANNEL_INFO:
      return {
        ...state,
        workingChannelInfo: action.data,
      };

    case COMMON_SET_WHATSAPP_CHANNEL_INFO:
      const members = [...action.data.members];
      const mappedMembers = members.map(member => ({
        id: member.user.id,
        name: member.user.name,
        role: member.user.role,
        title: member.user.title,
        photo: member.user.photo,
      }));
      return {
        ...state,
        workingWhatsappChannelInfo: { ...action.data, all_members: mappedMembers },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/setChannelInfo.js